var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"customer-keine-daten mb-0 mt-3",attrs:{"value":true,"type":"info"}},[_vm._v(" Es liegen aktuell keine Daten vor. ")])}
var staticRenderFns = []

export { render, staticRenderFns }